
































































import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';

const cssPrefix = 'sw-tree-list-plus-trigger';

@Component({
  components: {
  },
})
export default class SwTreeListPlusTrigger extends SwExtendedVue {
  @Prop({ type: Boolean, default: false })
  withTrigger: boolean;

  @Prop({ type: Boolean, default: false })
  expanded: boolean;

  @Prop({ type: Boolean, default: false })
  isLast: boolean;

  cssPrefix = cssPrefix;
}
